"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BootstrapDialog;
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _AlertMessage = _interopRequireDefault(require("../objects/AlertMessage"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "page": "bootstrap_dialog-module__page___J2pJO",
  "container": "bootstrap_dialog-module__container___l6pzh",
  "au_header": "bootstrap_dialog-module__au_header___EinkZ",
  "tmc_header": "bootstrap_dialog-module__tmc_header___mqu6h",
  "header_icon": "bootstrap_dialog-module__header_icon___f5agV",
  "copyright": "bootstrap_dialog-module__copyright___tGS5D"
};
function BootstrapDialog(props) {
  let header = /*#__PURE__*/_react.default.createElement("div", {
    className: styles.au_header
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles.header_icon, 'icon-tmc-logo')
  }));
  if (props.headerId || props.headerString) {
    header = /*#__PURE__*/_react.default.createElement("div", {
      className: styles.tmc_header
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: (0, _classnames.default)(styles.header_icon, 'icon-tmc-logo'),
      displayId: props.headerId,
      displayString: props.headerString,
      tag: "div"
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, null), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.page
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.container
  }, header, props.children), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
    className: styles.copyright,
    displayId: "au.copyright",
    values: {
      year: new Date().getFullYear()
    },
    tag: "p"
  })));
}
BootstrapDialog.propTypes = {
  headerId: T.string,
  headerString: T.string,
  children: T.oneOfType([T.element, T.arrayOf(T.element)]).isRequired
};